import { ReactComponent as moneyRecive } from 'src/integration/assets/icons/ic_money-recive.svg';
import { ReactComponent as sun } from 'src/integration/assets/icons/ic_sun.svg';
import { ReactComponent as plus } from 'src/integration/assets/icons/ic_plus.svg';
import { ReactComponent as minus } from 'src/integration/assets/icons/ic_minus.svg';
import { ReactComponent as burgerMenu } from 'src/integration/assets/icons/ic_menu.svg';
import { ReactComponent as user } from 'src/integration/assets/icons/ic_user.svg';
import { ReactComponent as alertDefault } from 'src/integration/assets/icons/ic_alert-default.svg';
import { ReactComponent as key } from 'src/integration/assets/icons/ic_key.svg';
import { ReactComponent as logout } from 'src/integration/assets/icons/ic_logout.svg';
import { ReactComponent as dots } from 'src/integration/assets/icons/ic_dots.svg';
import { ReactComponent as arrowDown } from 'src/integration/assets/icons/ic_arrow-down.svg';
import { ReactComponent as calendar } from 'src/integration/assets/icons/ic_calendar.svg';
import { ReactComponent as battery } from 'src/integration/assets/images/im-battery.svg';

import { ReactComponent as graph } from 'src/integration/assets/images/im_graph.svg';
import logo from 'src/integration/assets/images/im_logo-enerheads.png';


export const iconMoneyRecive = moneyRecive;
export const iconSun = sun;
export const iconPlus = plus;
export const iconMinus = minus;
export const iconBurgerMenu = burgerMenu;
export const iconUser = user;
export const iconAlertDefault = alertDefault;
export const iconKey = key;
export const iconLogout = logout;
export const iconDots = dots;
export const iconArrowDown = arrowDown;
export const iconCalendar = calendar;

export const imageGraph = graph;
export const imageLogo = logo;
export const imageBattery = battery;


